import React, { useId, useState } from "react";
import { observer } from "mobx-react-lite";
import { SideDrawer, SideDrawerCloseButton } from "@dmc/ui";
import ApiData from "../../../api/ApiData";
import Msg from "../../../api/Msg";
import useValidationText from "../../../hooks/useValidationText";
import useValidationPhone from "../../../hooks/useValidationPhone";
import { InputEditVer1 } from "../../UI/InputEditVer1";
import { SiteFormField } from "../../UI/SiteFormField";
import { BtnOutlineV4 } from "../../UI/button/BtnOutlineV4";
import { BtnPrimaryv4 } from "../../UI/button/BtnPrimaryv4";

export const CompanyClientLkRegisterModal = observer(
  ({ companyId, onClose }) => {
    const titleId = useId();
    const [submitting, setSubmitting] = useState(false);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [fatherName, setFatherName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");

    const validPhone = useValidationPhone(phone);
    const validFirstName = useValidationText(firstName);
    const validLastName = useValidationText(lastName);
    const validFatherName = useValidationText(fatherName);

    const close = () => {
      if (!submitting) {
        onClose();
      }
    };

    const onSave = async () => {
      if (lastName.trim() === "" || firstName.trim() === "" || email === "" || phone === "") {
        return Msg.writeMessages("Не все обязательные поля заполнены");
      }
      if (!email.match(/\w*[@]\w{2,8}[.]\w{2,4}/u)) {
        return Msg.writeMessages("Неверный формат email");
      }

      const body = {
        last_name: lastName.trim(),
        first_name: firstName.trim(),
        email: email.toLocaleLowerCase().trim(),
        phone,
      };
      const fatherTrimmed = fatherName.trim();
      if (fatherTrimmed !== "") {
        body.father_name = fatherTrimmed;
      }

      setSubmitting(true);
      const result = await ApiData.registerClientLkSuperuser(companyId, body);
      setSubmitting(false);

      if (!result) {
        return;
      }

      Msg.writeMessages(
        "Сообщите выданный пароль клиенту - пользователю ЛК DMC для клиентов",
      );
      onClose();
    };

    return (
      <SideDrawer
        title="Регистрация администратора ЛК клиента"
        titleId={titleId}
        onClose={close}
        usePortal={false}
        toolbar={<SideDrawerCloseButton onClick={close} title="Закрыть" />}
        footer={
          <>
            <BtnPrimaryv4
              footerSize
              text={submitting ? "Сохранение…" : "Сохранить"}
              onClick={onSave}
            />
            <BtnOutlineV4 text="Закрыть" onClick={close} />
          </>
        }
      >
        <div className="site-modal-body">
          <div className="site-modal-fields company-edit-grid">
            <SiteFormField label="Email" full>
              <InputEditVer1
                className="site-form-control"
                placeholder="e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </SiteFormField>
            <SiteFormField label="Фамилия">
              <InputEditVer1
                className="site-form-control"
                placeholder="Введите фамилию"
                value={validLastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </SiteFormField>
            <SiteFormField label="Имя">
              <InputEditVer1
                className="site-form-control"
                placeholder="Введите имя"
                value={validFirstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </SiteFormField>
            <SiteFormField label="Отчество">
              <InputEditVer1
                className="site-form-control"
                placeholder="Необязательно"
                value={validFatherName}
                onChange={(e) => setFatherName(e.target.value)}
              />
            </SiteFormField>
            <SiteFormField label="Телефон">
              <InputEditVer1
                className="site-form-control"
                placeholder="Введите телефон"
                type="number"
                value={validPhone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </SiteFormField>
          </div>
        </div>
      </SideDrawer>
    );
  },
);
